import { BookitupScope } from '../../../Service/ProfileS';

export type BookitupScopeOption = {
  scope: BookitupScope;
  title: string;
  description: string;
  hiddenWhenSelected?: BookitupScope;
  replacesScope?: BookitupScope;
};

export type BookitupScopeGroup = {
  title: string;
  description: string;
  options: BookitupScopeOption[];
};

export const moduleScopeGroups: BookitupScopeGroup[] = [
  {
    title: 'Module',
    description: 'Wähle aus, welche Bereiche dieses Teammitglied öffnen und nutzen darf.',
    options: [
      {
        scope: 'RESOURCE',
        title: 'Ressourcen',
        description: 'Erlaubt Zugriff auf Ressourcen, Bestände und Ressourcenplanung.',
      },
      {
        scope: 'CONTACTS',
        title: 'Kontakte',
        description: 'Erlaubt Zugriff auf Kontakte und Kontaktdetails.',
      },
      {
        scope: 'EMAILS',
        title: 'E-Mails',
        description: 'Erlaubt Zugriff auf das Postfach und die E-Mail-Kommunikation.',
      },
      {
        scope: 'DOCUMENTS',
        title: 'Dokumente',
        description: 'Erlaubt Zugriff auf Dokumente, Vorlagen und dokumentbezogene Abläufe.',
      },
      {
        scope: 'CONTRACTS',
        title: 'Verträge',
        description: 'Erlaubt Zugriff auf Verträge und vertragsbezogene Dokumente.',
      },
      {
        scope: 'QUESTIONNAIRES',
        title: 'Fragebögen',
        description: 'Erlaubt Zugriff auf Fragebögen und dazugehörige Antworten.',
      },
      {
        scope: 'STATISTICS',
        title: 'Statistiken',
        description: 'Erlaubt Zugriff auf Auswertungen, Kennzahlen und Statistiken.',
      },
      {
        scope: 'SETTINGS',
        title: 'Einstellungen',
        description: 'Erlaubt Zugriff auf Profil-, Team- und App-Einstellungen.',
      },
    ],
  },
];

export const visibilityScopeGroups: BookitupScopeGroup[] = [
  {
    title: 'Sichtbarkeit',
    description:
      'Lege fest, ob dieses Teammitglied nur eigene Zuordnungen oder auch weitere Aufgaben, Events und Dateien sehen darf.',
    options: [
      {
        scope: 'GENERAL_TASKS',
        title: 'Alle Aufgaben',
        description: 'Erlaubt lesenden Zugriff auf alle Aufgaben, auch wenn sie nicht direkt zugewiesen sind.',
        replacesScope: 'UNASSIGNED_TASKS',
      },
      {
        scope: 'UNASSIGNED_TASKS',
        title: 'Nicht zugewiesene Aufgaben',
        description: 'Erlaubt lesenden Zugriff auf Aufgaben, die keinem Teammitglied direkt zugewiesen sind.',
        hiddenWhenSelected: 'GENERAL_TASKS',
      },
      {
        scope: 'GENERAL_EVENTS',
        title: 'Alle Events',
        description: 'Erlaubt lesenden Zugriff auf alle Events, auch wenn sie nicht direkt zugewiesen sind.',
        replacesScope: 'UNASSIGNED_EVENTS',
      },
      {
        scope: 'UNASSIGNED_EVENTS',
        title: 'Nicht zugewiesene Events',
        description: 'Erlaubt lesenden Zugriff auf Events, die keinem Teammitglied direkt zugewiesen sind.',
        hiddenWhenSelected: 'GENERAL_EVENTS',
      },
      {
        scope: 'EVENT_UPLOADS',
        title: 'Event-Uploads',
        description: 'Erlaubt Zugriff auf Uploads und Dateien, die an Events hinterlegt sind.',
      },
      {
        scope: 'RECEIVE_SYSTEM_EMAILS',
        title: 'System-E-Mails',
        description: 'Das Teammitglied erhält System-E-Mails wie neue Anfragen oder Antworten auf Empfehlungen.',
      },
    ],
  },
];
